import React, { Component } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import {
  showCtagRulePreview,
  getCtagRuleDetails,
  emptyCtagRulePreview
} from "../../../redux/actions/MlTrackLibraryActions";


class PostStat extends Component {

  showCtagRules = (track, ctags) => {

    const { data: { ctagRuleList } } = this.props

    var cTagIds = [];
    ctags.forEach((item) => {
      cTagIds.push(item.ctagId)
    })
    const { showCtagRulePreview, getCtagRuleDetails } = this.props;
    showCtagRulePreview(true);
    emptyCtagRulePreview();
    if (ctagRuleList.length <= 0) {
      getCtagRuleDetails({ trackId: track.id, cTagIds: cTagIds }, ctags)
    }
  }

  cTagListRenderer = (cTagList) => {
    const { track } = this.props;
    let filteredCtags = cTagList?.filter(r => (r.result === undefined || r.result === true) && r.indicator);
    if (filteredCtags && filteredCtags.length > 0) {
      return filteredCtags.map((r, i) => <span onClick={() => this.showCtagRules(track, cTagList)} title={r.name} className={`explicitContents cTag${i + 1}`} style={{ fontSize: "10px", background: r.colour, color: "#fff" }}>{r.indicator}</span>);
      //return filteredCtags.filter((r, i) => i < 3).map((r, i) => <span onClick={() => this.showCtagRules(track, cTagList)} className={`explicitContents cTag${i + 1}`} style={{ fontSize: "10px", background: r.colour, color: "#fff" }}>{r.indicator}</span>);
    } else {
      return null;
    }
  };

  render() {
    const { track, postUpdating } = this.props;

    return (
      <Translation>
        {(t, { i18n }) => {
          return (
            <>
              {!postUpdating && track.cTagList && track.cTagList.length > 0 ? (
                this.cTagListRenderer(track.cTagList)
              ) : (
                postUpdating ? <span title={t("libraryTools.cTagStatus")} style={{ fontSize: "9px", color: "yellow" }}>...</span> : null
              )}
            </>
          );
        }}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.mltracklibrary,
});

export default connect(mapStateToProps, {
  showCtagRulePreview,
  getCtagRuleDetails,
  emptyCtagRulePreview
})(PostStat);
